import {
    createAsyncThunk,
    createSlice } from "@reduxjs/toolkit";
import { snpAxios } from "../components/global/api";
import {
  SUCCESS,
  getPreUrlAccordingToCart,
  getAuthSession,
  printDebugLog
} from "../constants/constant";

const restoBillConfigSlice = createSlice({
  name: "restobillConfig",
  initialState: {
    configs: {},
    loading: false,
    error: null,
    currentRequestId: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllConfigs.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(fetchAllConfigs.fulfilled, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) return;
        state.loading = false;
        state.configs = action.payload;
        state.currentRequestId = null;
      })
      .addCase(fetchAllConfigs.rejected, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) return;
        printDebugLog("error in fetching config: ", action.payload);
        state.loading = false;
        state.error = action.payload;
        state.currentRequestId = null;
      });
  },
});

export const fetchAllConfigs = createAsyncThunk(
  "restoBillConfig/fetchAllConfigs",
  async (configNames, thunkAPI) => {
    const state = thunkAPI.getState();
    const storeApiUrl = state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL;
    const shopHash = state.setActiveShopHashReducer.activeShopHash;
    let fetchConfigUrl =
      storeApiUrl?.BACKEND_BASE_URL +
      getPreUrlAccordingToCart(shopHash.cartType) +
      "get-multiple-configs";
    let data = {
      jcJson: {
        apiToken: getAuthSession().apiToken,
        listConfigs: configNames,
        shopHash: shopHash?.id,
      },
    };

    try {
      const response = await snpAxios.post(fetchConfigUrl, data, {
        signal: thunkAPI.signal,
      });
      if (response.data.status === SUCCESS) {
        const restoConfig = populateConfig(response.data.jcJson.mapConfigs);
        return restoConfig;
      } else {
        return thunkAPI.rejectWithValue({
          status: response.data.status,
          message: response.data.message,
        });
      }
    } catch (error) {
      console.error("Fetch Config Error: ", error);
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch bill config details"
      );
    }
  }
);

export const restoBillConfigReducer = restoBillConfigSlice.reducer;

export const isEnabledConfigValue = (value) => {
  if (typeof value === "string") {
    return ["yes", "true", "1"].includes(value.trim().toLowerCase());
  }
  return value === true || value === 1;
};

export const populateConfig = (configMap) => {
  //let config = {};
  console.log("configMap: ", configMap);
  // configMap && Object.entries(configMap).forEach(([key, value]) => {
  //     config[key] = "Yes" === value
  //    });
  const config = Object.fromEntries(
    Object.entries(configMap || {}).map(([key, value]) => [
      key,
      isEnabledConfigValue(value),
    ])
  );
  printDebugLog("config", config);
  return config;
};
